import { render } from "./ResultsSummary.vue?vue&type=template&id=cd19f4e6"
import script from "./ResultsSummary.vue?vue&type=script&lang=js"
export * from "./ResultsSummary.vue?vue&type=script&lang=js"

import "./ResultsSummary.vue?vue&type=style&index=0&id=cd19f4e6&this=true&d=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__